import { useCallback, useState } from 'react';

import { defaultLimit } from 'views/CRM/shared/utils/pagination';

import contactService from '../services/contactService';
import TagClientService from 'views/CRM/Tags/services/TagClientService';

export const useListContacts = ({ recordTypeId, sortConfig }) => {
  const [contacts, setContacts] = useState();
  const [totalContacts, setTotalContacts] = useState();
  const [isLoadingContacts, setIsLoadingContacts] = useState(false);

  const getContacts = useCallback(
    (page = 1, params = {}) => {
      const orderType =
        sortConfig?.direction === null ||
        sortConfig?.direction === undefined ||
        sortConfig?.direction === 'ascending'
          ? 'ASC'
          : 'DESC';

      const orderBy = sortConfig?.key;
      setIsLoadingContacts(true);

      contactService
        .getContacts(
          recordTypeId,
          { ...params, orderType, orderBy },
          {
            page,
            limit: defaultLimit
          }
        )
        .then(async (response) => {
          const tags = await TagClientService.getAll({
            showDisabled: true
          });

          const existsTags = tags?.data?.data?.length > 0;
          let dataToTable = [...response.data.data];

          if (existsTags) {
            const tagIdName = {};
            tags.data.data.forEach((tag) => {
              tagIdName[tag.id] = tag;
            });

            dataToTable.forEach((conversa) => {
              if (conversa?.tags && conversa?.tags.length > 0)
                conversa.tags = conversa?.tags?.map((tag) => {
                  return tagIdName[tag];
                });
            });
          }

          setContacts(dataToTable);
          setTotalContacts(response.data.totalRegisters);
        })
        .finally(() => setIsLoadingContacts(false));
    },
    [recordTypeId, sortConfig]
  );

  const clearContacts = useCallback(() => {
    setContacts(null);
    setTotalContacts(0);
    setIsLoadingContacts(false);
  }, []);

  return {
    contacts,
    totalContacts,
    isLoadingContacts,
    getContacts,
    clearContacts
  };
};
